import React, { useState } from 'react'
import styled from '@emotion/styled'
import { useTheme } from 'emotion-theming'
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles'
import { Tab, Tabs as MuiTabs } from '@material-ui/core'
import { arrayOf, func, shape, string } from 'prop-types'

const TabsContainer = styled.div`
	width: 100%;
`

const getMuiThemeWithOverrides = (theme) =>
	createMuiTheme({
		typography: {
			fontFamily: `'Poppins SemiBold', sans-serif`,
		},
		overrides: {
			MuiTabs: {
				root: {
					background: theme.colors.tertiary,
					color: theme.colors.white,
				},
				indicator: {
					display: 'none',
				},
			},
			MuiTab: {
				root: {
					background: theme.colors.tertiary,
					borderTopLeftRadius: '5px',
					borderTopRightRadius: '5px',
					height: '34px',
					lineHeight: '27px',
					maxWidth: 'none',
					padding: '0 1rem',
					transition: '.2s ease all',
					'&$textColorInherit': {
						opacity: 1,
					},
					'&$selected': {
						backgroundColor: theme.colors.white,
						color: theme.colors.primary,
					},
					[theme.MQ.S]: {
						fontSize: '18px',
						padding: '0 2rem',
					},
				},
			},
			MuiTabScrollButton: {
				root: {
					flexShrink: 'inherit',
				},
			},
		},
	})

Tabs.propTypes = {
	tabData: arrayOf(
		shape({
			label: string.isRequired,
			panel: func.isRequired,
		})
	),
}

/**
 * Tabs Component, displays number of tabs and elements within the corresponding tab body
 *
 * @param {Array} props.tabData :: list of tab required data - label for the tab and panel component for tab body
 */
export function Tabs({ tabData }) {
	const theme = useTheme()
	const [currentTab, setCurrentTab] = useState(0)

	const handleTabChange = (event, newTab) => {
		setCurrentTab(newTab)
	}

	return (
		<TabsContainer>
			<MuiThemeProvider theme={getMuiThemeWithOverrides(theme)}>
				<MuiTabs onChange={handleTabChange} value={currentTab} variant="scrollable">
					{tabData
						.filter((isDefined) => !!isDefined)
						.map((tab, i) => {
							return tab && <Tab key={`tab-${i}`} label={tab.label} index={i} />
						})}
				</MuiTabs>
			</MuiThemeProvider>
			{tabData
				.filter((isDefined) => !!isDefined)
				.map((tab, i) => {
					return (
						tab && (
							<div hidden={currentTab !== i} key={`panel-${i}`} role="tabpanel">
								<tab.panel />
							</div>
						)
					)
				})}
		</TabsContainer>
	)
}
